// extracted by mini-css-extract-plugin
export var RecruitNav = "RecruitNav-module--RecruitNav--3lYnS";
export var RecruitNav__btn = "RecruitNav-module--RecruitNav__btn--2oAaC";